import React, { useEffect, useRef, useState } from "react"
import Button from "screens/components/basic/Button";
import DeleteIcon from '@mui/icons-material/Delete';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import UploadIcon from '@mui/icons-material/Upload';
import 'react-image-crop/dist/ReactCrop.css'
import "./style.scss"
import { canvasPreview } from "./widgets/canvasPreview";
import { useDebounceEffect } from "./widgets/useDebounceEffect";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";

const SelectImageWithCrop = ({ handleUpload, uploadPending, uploadSuccess }) => {

  const [imgSrc, setImgSrc] = useState('')
  const previewCanvasRef = useRef(null)
  const imgRef = useRef(null)
  const [crop, setCrop] = useState()
  const [completedCrop, setCompletedCrop] = useState()


  ////------------------

  useEffect(() => {
    if (uploadSuccess) {
      setCompletedCrop()
      setCrop()
      setImgSrc()
    }
  }, [uploadSuccess])


  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget
    setCrop(centerAspectCrop(width, height, 1))

  }

  const getFileContent = async () => {
    const image = imgRef.current;
    if (!image || !completedCrop) {
      throw new Error('Crop canvas does not exist');
    }
  
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
  
    // Calculate the original width and height
    const cropWidth = completedCrop.width * scaleX;
    const cropHeight = completedCrop.height * scaleY;
  
    // At least 800x800, if below, using the current size
    const outputSize = Math.max(800, cropWidth, cropHeight);
  
    const canvas = document.createElement('canvas');
    canvas.width = outputSize;
    canvas.height = outputSize;
  
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('No 2d context');
    }
  
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  
    const dx = (outputSize - cropWidth) / 2;
    const dy = (outputSize - cropHeight) / 2;
  
    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      cropWidth,
      cropHeight,
      dx,
      dy,
      cropWidth,
      cropHeight
    );
  
    const base64Image = canvas.toDataURL('image/png');
    console.log('[Image base64]', base64Image);
    return base64Image;
  };
  

  useDebounceEffect(
    async () => {
      if (
        completedCrop && completedCrop.width &&
        completedCrop && completedCrop.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop
        )
      }
    },
    100,
    [completedCrop],
  )


  const handleSubmitFileToParent = async () => {
    const imageBase64 = await getFileContent()
    handleUpload(imageBase64)

  }
  const handleFileChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files.length > 0) {
      setCrop(undefined)
      const reader = new FileReader()
      reader.addEventListener('load', () =>
        setImgSrc(reader.result.toString() || ''),
      )
      reader.readAsDataURL(e.target.files[0])
    }
  };
  return (

    <div  >
      <div className="image-upload-crop-container" >
        {!!imgSrc && (<div className="d-flex justify-content-center align-items-center "
          style={{ backgroundColor: '#000', width: '100%', height: '100%' }}
        >

          <ReactCrop
            crop={crop}
            onChange={(_, percentCrop) => setCrop(percentCrop)}
            onComplete={(c) => setCompletedCrop(c)}
            aspect={1}
            minHeight={100}>
            <img
              ref={imgRef}
              alt="Crop me"
              src={imgSrc}
              onLoad={onImageLoad}
              width={300}
            />
          </ReactCrop>
          {!!completedCrop && (

            <div className="multi-product-image-context">
              <canvas
                ref={previewCanvasRef}
                style={{
                  border: '1px solid black',
                  objectFit: 'contain',
                  width: completedCrop.width,
                  height: completedCrop.height,
                }}
              />
            </div>


          )}

        </div>)}


      </div>
      <div className="d-flex justify-content-center mt-3">
        {imgSrc && <React.Fragment>
          <Button
            className=" mr-2"
            type="IconInButton"
            label={"Remove Image"}
            icon={<DeleteIcon />}
            onTouchTap={() => {
              setImgSrc()
              setCompletedCrop()
            }} />
          <Button
            type="IconInButton"
            className="bg-light-green"
            label={"Save Image"}
            icon={<SaveAltIcon />}
            dispatch={uploadPending}
            onTouchTap={handleSubmitFileToParent} />
        </React.Fragment>}
        {!imgSrc &&
          <Button
            component="label"
            dx={{ ...styles.uploadButton }}
            primary={true}
            className="pull-left"
            style={{ marginTop: 1 }}
          >
            <UploadIcon />  Upload Image
            <input className="fileInput"
              type="file"
              style={styles.uploadInput}
              onChange={handleFileChange} />
          </Button>}
      </div>

    </div>


  )
}


export default SelectImageWithCrop


const centerAspectCrop = (
  mediaWidth,
  mediaHeight,
  aspect,
) => {
  return centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: 90,
      },
      aspect,
      mediaWidth,
      mediaHeight,
    ),
    mediaWidth,
    mediaHeight,
  )
}

const styles = {
  uploadButton: {
    verticalAlign: 'middle', marginTop: '0 !important'
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0
  }
};
